/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
import React, {
  useState, useEffect, useContext,
} from 'react';
import { Users, User } from 'lucide-react';
import AddModal from './AddModal';
import '../settings.css';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { UserContext } from '../../../contexts/User';
import { NotificationContext } from '../../../contexts/Notification';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../../utils/styledSelect';

function TeamVisibilityControls() {
  const {
    displayNotification,
  } = useContext(NotificationContext);
  const { activeWorkspace } = useContext(UserContext);
  const [allTeams, setAllTeams] = useState([]);
  const [allMembers, setAllMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const getAllTeams = async () => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getAllTeamInfo(activeWorkspace.id),
      timeout: 60000,
    });

    if (response.success) {
      setAllTeams(response.data.teams);
    }
  };

  const getAllMembers = async () => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.members(activeWorkspace.id),
    });
    if (response.success) {
      const mappedmembers = response.data?.members.map((member) => ({
        id: member.id,
        name: member.user?.fullName,
      }));
      setAllMembers(mappedmembers);
    }
  };

  const getTeamVisibilityControls = async (teamId) => {
    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getTeamVisibilityControls(activeWorkspace.id, teamId),
      timeout: 60000,
    });

    if (response.success) {
      setTeams([]);
      setMembers([]);
      response.data?.visibilityControls?.forEach((controlInfo) => {
        if (controlInfo.viewerType === 1) {
          // viewerType is Team
          allTeams.forEach((team) => {
            if (team.id === controlInfo.viewerId) {
              const newTeamInfo = {
                id: teams.length + 1,
                name: team.name,
                accessLevel: controlInfo.accessLevel,
              };
              setTeams((prevTeams) => [...prevTeams, newTeamInfo]);
            }
          });
        } else {
          // viewerType is Member
          allMembers.forEach((member) => {
            if (member.id === controlInfo.viewerId) {
              const newMemberInfo = {
                id: members.length + 1,
                name: member.name,
                accessLevel: controlInfo.accessLevel,
              };
              setMembers((prevMembers) => [...prevMembers, newMemberInfo]);
            }
          });
        }
      });
    }
  };

  const deleteTeamVisibilityControls = async (control) => {
    const response = await sendRequest({
      method: 'delete',
      url: API.WORKSPACE.deleteTeamVisibilityControls(activeWorkspace.id),
      data: { control },
    });

    if (response.success) {
      displayNotification({
        message: 'Delete Team Visibility Control successfully',
        severity: 'success',
      });
      getTeamVisibilityControls(control.teamId);
    } else {
      displayNotification({
        message: 'An error occurs while saving visibility control',
        severity: 'error',
      });
    }
  };

  const setTeamVisibilityControls = async (control) => {
    const response = await sendRequest({
      method: 'post',
      url: API.WORKSPACE.setTeamVisibilityControls(activeWorkspace.id),
      data: { control },
    });

    if (response.success) {
      displayNotification({
        message: 'Create Team Visibility Control successfully',
        severity: 'success',
      });
      getTeamVisibilityControls(control.teamId);
    } else {
      displayNotification({
        message: 'An error occurs while saving visibility control',
        severity: 'error',
      });
    }
  };

  const addViewer = (viewerId, viewerType, accessLevel) => {
    const control = {
      teamId: selectedIndex ? allTeams[selectedIndex - 1].id : 0,
      viewerId,
      viewerType,
      accessLevel,
    };
    setTeamVisibilityControls(control);
  };

  const updateTeamVisibilityControls = async (control) => {
    const response = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.updateTeamVisibilityControls(activeWorkspace.id),
      data: { control },
    });

    if (response.success) {
      displayNotification({
        message: 'Update Team Visibility Control successfully',
        severity: 'success',
      });
      getTeamVisibilityControls(control.teamId);
    } else {
      displayNotification({
        message: 'An error occurs while saving visibility control',
        severity: 'error',
      });
    }
  };

  const handleTeamChanged = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === 'All Team') {
      getTeamVisibilityControls(0);
      setSelectedIndex(0);
    } else {
      const index = allTeams.findIndex((team) => team.name === selectedValue);
      setSelectedIndex(index + 1);
      getTeamVisibilityControls(allTeams[index].id);
    }
  };

  const removeViewer = (viewerId, viewerType) => {
    const control = {
      teamId: selectedIndex ? allTeams[selectedIndex].id : 0,
      viewerId,
      viewerType,
    };
    deleteTeamVisibilityControls(control);
  };

  const handleSelectChanged = (name, viewerType, value) => {
    if (viewerType === 1) {
      teams.map((team) => (team.name === name ? { ...team, accessLevel: value } : team));
      const control = {
        teamId: selectedIndex ? allTeams[selectedIndex - 1].id : 0,
        viewerId: allTeams[allTeams.findIndex((t) => t.name === name)].id,
        viewerType,
        accessLevel: value,
      };
      updateTeamVisibilityControls(control);
    } else {
      members.map((member) => (member.name === name ? { ...member, accessLevel: value } : member));
      const control = {
        teamId: selectedIndex ? allTeams[selectedIndex - 1].id : 0,
        viewerId: allMembers[allMembers.findIndex((m) => m.name === name)].id,
        viewerType,
        accessLevel: value,
      };
      updateTeamVisibilityControls(control);
    }
  };

  useEffect(() => {
    if (allTeams && allMembers) {
      getTeamVisibilityControls(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allTeams, allMembers]);

  useEffect(() => {
    getAllTeams();
    getAllMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // value 0 = Full Access, 1 = Limited Access, 2 = Remove
  const handleAccessSelect = (name, viewerType, value) => {
    if (value === 2) {
      const pool = viewerType === 1 ? allTeams : allMembers;
      removeViewer(pool[pool.findIndex((v) => v.name === name)].id, viewerType);
    } else {
      handleSelectChanged(name, viewerType, value);
    }
  };

  const renderRow = (item, viewerType) => (
    <div key={`${viewerType}-${item.name}`} className="flex items-center justify-between px-3 py-2.5">
      <span className="flex items-center gap-2.5 min-w-0">
        {viewerType === 1
          ? <Users size={16} className="text-ink-500 flex-shrink-0" />
          : <User size={16} className="text-ink-500 flex-shrink-0" />}
        <span className="text-sm text-ink-900 truncate">{item.name}</span>
      </span>
      <select
        value={item.accessLevel}
        onChange={(e) => handleAccessSelect(item.name, viewerType, Number(e.target.value))}
        className={STYLED_SELECT_CLASS}
        style={{ ...STYLED_SELECT_STYLE, width: 160, flexShrink: 0 }}
      >
        <option value={0}>Full Access</option>
        <option value={1}>Limited Access</option>
        <option value={2}>Remove</option>
      </select>
    </div>
  );

  const sectionTitle = 'text-sm font-semibold text-ink-900';
  const listBox = 'border border-rule rounded-[8px] divide-y divide-rule';

  return (
    <div className="px-4 py-4" style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-5">
        <div className="min-w-0">
          <h4 className="text-base font-semibold text-ink-900 mb-0.5">Configure Team Visibility</h4>
          <p className="text-sm text-ink-500">Define who can view specific teams and members.</p>
        </div>
        <select
          defaultValue="All Team"
          onChange={handleTeamChanged}
          className={`${STYLED_SELECT_CLASS} min-w-[180px]`}
          style={STYLED_SELECT_STYLE}
        >
          <option value="All Team">All Team</option>
          {allTeams.map((team) => <option key={team.id} value={team.name}>{team.name}</option>)}
        </select>
      </div>

      <div className="flex flex-col gap-6">
        {/* Team-Level Visibility */}
        <section>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Users size={18} className="text-brand-700" />
              <h5 className={sectionTitle}>Team-Level Visibility</h5>
            </div>
            <AddModal viewerType={1} viewers={allTeams.filter((t) => !teams.some((a) => a.name === t.name))} onSaved={addViewer} />
          </div>
          <div className={listBox} style={{ borderStyle: 'solid' }}>
            {teams.length ? teams.map((team) => renderRow(team, 1)) : (
              <p className="px-3 py-5 text-sm text-ink-500 text-center">No teams added yet.</p>
            )}
          </div>
        </section>

        {/* Individual Member Access */}
        <section>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <User size={18} className="text-brand-700" />
              <h5 className={sectionTitle}>Individual Member Access</h5>
            </div>
            <AddModal viewerType={2} viewers={allMembers.filter((m) => !members.some((a) => a.name === m.name))} onSaved={addViewer} />
          </div>
          <div className={listBox} style={{ borderStyle: 'solid' }}>
            {members.length ? members.map((member) => renderRow(member, 2)) : (
              <p className="px-3 py-5 text-sm text-ink-500 text-center">No members added yet.</p>
            )}
          </div>
        </section>
      </div>
    </div>
  );
}

export default TeamVisibilityControls;
